var SCM = SCM || {};

SCM.Modals = (function ($) {
    var GlobalModalContainerId = 'globalModalContainer';
    var GlobalModalContentWrapperId = 'globalModalContent';
    var ModalSourceIdAttr = 'data-modal-source-id';
    var ModalAjaxUrlAttr = 'data-modal-source-url';
    var ModalContentAttr = 'data-content-id';
    var LegacyContentAttr = 'content-id';
    var SwapModalContentAttr = 'swap-content-for-modal';
    var $globalModal;
    var $globalModalContentWrapper;
    var $globalModalPlaceholder;
    var $body;
    var $jqueryObj = null; // used to trigger events on the relevant jquery object shown by the modal
    var lastActiveElement = null;
    var CloseModalClass = 'js-close-modal';
    var ScreenreaderTextClass = 'screenreader-text';
    var defaultCloseScreenreaderText = null;

    var events = {
        open: 'scm.modals.open',
        close: 'scm.modals.close'
    };

    return {
        Events: events,
        init: _init,
        showModal: _showModal,
        closeModal: _closeModal,
        isTriggerToSplitPane: _isTriggerToSplitPane,
        getJQueryObjects: _getJQueryObjects
    };


    function _init() {
        $body = $(document.body);
        $globalModal = $('#' + GlobalModalContainerId);
        $globalModalContentWrapper = $('#' + GlobalModalContentWrapperId);
        $globalModalPlaceholder = $('.js-globalModalPlaceholder');
        _cacheDefaultCloseLabels();
        _wireModalTriggers();
    }

    function _wireModalTriggers() {
        $body.on(
            'click',
            '*[' + ModalSourceIdAttr + '], *[' + ModalAjaxUrlAttr + ']',
            _handleModalTriggerClick
        );
        $body.on('click keydown', '.js-close-modal', function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === 'Space'))) {
                e.preventDefault();
                _closeModal();
            }
        });
        $body.on('click', '.js-modal-overlay', _closeModal);
        $body.on('keyup', function (e) {
            if (e && e.code && e.code.toLowerCase() === 'escape' && $globalModal.hasClass('open')) {
                _closeModal();
            }
        });
    }

    function _handleModalTriggerClick(e) {
        var $trigger = $(e.currentTarget);
        if (_isTriggerToSplitPane($trigger)) {
            return;
        }
        e && e.preventDefault && e.preventDefault();
        var contentId = $trigger.data(_getDatasetKey(ModalSourceIdAttr));
        contentId = contentId ? contentId.trim().toLowerCase() : contentId;
        if (contentId) {
            _showModalForContentId(contentId);
        } else {
            var sourceAjaxUrl = $trigger.data(_getDatasetKey(ModalAjaxUrlAttr));
            sourceAjaxUrl = sourceAjaxUrl ? sourceAjaxUrl.trim() : sourceAjaxUrl;
            _showModalForAjax(sourceAjaxUrl);
        }
    }

    function _isSplitView() {
        return !!$('.pg_ArticleSplitView, .pg_articlesplitview').length;
    }

    function _isTriggerToSplitPane($trigger) {
        return _isSplitView() && !!$trigger.hasClass('xref-bibr');
    }

    function _showModalForContentId(contentId) {
        if (!contentId || typeof contentId !== 'string') {
            return;
        }
        var cssSelector = contentId.split(' ')
            .map(function(c) {
                return '*[' + ModalContentAttr + '="' + c + '" i], *[' + LegacyContentAttr + '="' + c + '" i]';
            })
            .join(', ');
        if (!cssSelector) {
            return;
        }

        _showModal(_getJQueryObjects(cssSelector));
    }

    function _getJQueryObjects(cssSelector) {
        return $(cssSelector).filter(function (i, element) {
            return !_isInsideModalWrapper($(element));
        });
    }

    function _isInsideModalWrapper($element) {
        return $element.closest('#' + GlobalModalContentWrapperId).length;
    }

    function _showModalForAjax(ajaxUrl) {
        if (!ajaxUrl)
            return;
        SCM.Ajax.get(ajaxUrl)
            .expectHtml()
            .then(function (result) {
                _showModal(result);
            })
            .catch(function (reason) {
                console.error('Failed to display AJAX modal content.  ', reason);
            });
    }

    /**
     * Show the global modal container with the provided contents.
     * It is not necessarily required to call this method directly.  Typically
     * all modal triggers will be auto-wired via the init method.
     * @param {string|JQuery} modalContents
     */
    function _showModal(modalContents) {
        if (modalContents && modalContents.trim) {
            modalContents = modalContents.trim();
        }
        if (!modalContents) {
            console.error('Request to show modal with no content');
            return;
        }

        if (typeof modalContents === 'string') {
            $globalModalContentWrapper.html(modalContents);            
            _openModal();
        } else if (_isJQueryObject(modalContents)) {
            $jqueryObj = modalContents;
            _showModelFromJqueryObject(modalContents);
        } else {
            console.error('Request to show modal with unsupported content type: ' + typeof modalContents);
        }
    }

    function _showModelFromJqueryObject($modalElement) {
        if ($modalElement.attr(SwapModalContentAttr) === 'true') {
            _showModalBySwappingContent($modalElement);
        } else {
            _showModal(_getHtmlFromJQueryObject($modalElement));
        }
    }

    function _showModalBySwappingContent($modalContents) {
        if ($globalModalPlaceholder.parent().attr('id') !== GlobalModalContentWrapperId) {
            // Something went wrong when the modal closed before, so we need to swap the modal's current content with the placeholder
            swapElements($globalModalPlaceholder, $globalModalContentWrapper.children());
        }
        swapElements($globalModalPlaceholder, $modalContents);

        _openModal();
    }

    function swapElements($element1, $element2) {
        var element1DOM = $element1[0];
        var element2DOM = $element2[0];
        var element1Parent = element1DOM.parentNode;
        var element2Parent = element2DOM.parentNode;
        var element1Sibling = element1DOM.nextSibling === element2DOM ? element1DOM : element1DOM.nextSibling;
        element2Parent.insertBefore(element1DOM, element2DOM);
        element1Parent.insertBefore(element2DOM, element1Sibling);
    }

    function _getHtmlFromJQueryObject($elements) {
        return $elements.get()
            .map(function (element) { return element.outerHTML; })
            .join('\n');
    }

    function _isJQueryObject(input) {
        return !!(input && input.jquery);
    }

    function _openModal() {
        $globalModalContentWrapper.find('.modal-only-content')
            .removeClass('modal-only-content');

        $body.addClass('modal-open');

        $globalModal.addClass('open');
        $globalModal.attr('aria-hidden', 'false');

        var $modalLabel = $globalModalContentWrapper.find('.js-modal-label');
        if ($modalLabel.length && $modalLabel.attr('id')) {
            $globalModal.attr('aria-labelledby', $modalLabel.attr('id'));
        }
        _setCloseButtonLabelFromTitle($modalLabel);

        lastActiveElement = document.activeElement;
        var $focusableElements = $globalModal.find(SCM.Focus.FocusableSelectorString)
            .filter(':visible:not(:disabled)');
        var $firstFocusable = $focusableElements.first();
        if ($firstFocusable.length) {
            $firstFocusable.focus();
        } else {
            $globalModal.attr('tabindex', '0').focus();
        }

        _triggerModalEvent(events.open);

        SCM.Focus.trap($globalModal);
    }

    function _closeModal() {
        if ($globalModalContentWrapper.children('[' + SwapModalContentAttr + ']').length !== 0) {
            swapElements($globalModalPlaceholder, $globalModalContentWrapper.children());
        } else {
            $globalModalContentWrapper.empty();
        }

        $body.removeClass('modal-open');

        $globalModal.removeClass('open');
        $globalModal.attr('aria-hidden', 'true');
        $globalModal.removeAttr('aria-labelledby');
        _resetCloseButtonLabel();

        _triggerModalEvent(events.close);
        $jqueryObj = null;

        SCM.Focus.release($globalModal);
        if (lastActiveElement) {
            lastActiveElement.focus();
            lastActiveElement = null;
        }
    }

    function _getGlobalCloseButton() {
        return $globalModal.children('.' + CloseModalClass);
    }

    function _cacheDefaultCloseLabels() {
        var $closeButton = _getGlobalCloseButton();
        if (!$closeButton.length) {
            return;
        }
        defaultCloseScreenreaderText = $closeButton.find('.' + ScreenreaderTextClass).text();
    }

    /**
     * Relabel the shared close button to name the modal that is opening,
     * e.g. a modal titled "Cover Image" yields "Close Cover Image modal".
     * Falls back to the default label when the modal has no title.
     * @param {JQuery} $modalLabel the modal's .js-modal-label element
     */
    function _setCloseButtonLabelFromTitle($modalLabel) {
        var $closeButton = _getGlobalCloseButton();
        if (!$closeButton.length) {
            return;
        }
        var titleText = $modalLabel.length ? $.trim($modalLabel.first().text()) : '';
        var closeLabel = titleText ? 'Close ' + titleText + ' modal' : defaultCloseScreenreaderText;
        $closeButton.find('.' + ScreenreaderTextClass).text(closeLabel);
    }

    function _resetCloseButtonLabel() {
        var $closeButton = _getGlobalCloseButton();
        if (!$closeButton.length) {
            return;
        }
        $closeButton.find('.' + ScreenreaderTextClass).text(defaultCloseScreenreaderText);
    }

    function _getDatasetKey(dataAttrName) {
        return dataAttrName.replace(/^data-/, '')
            .replace(/-([a-z])/g, function(match, p1) { return p1.toUpperCase(); });
    }

    /**
     * Trigger an event on the jQuery object or the global modal if jQuery object is not set
     * @param {string} event 
     */
    function _triggerModalEvent(eventName) {
        if ($jqueryObj && $jqueryObj.length) {
            $jqueryObj.trigger(eventName);
        } else if ($globalModal && $globalModal.length) {
            $globalModal.trigger(eventName);
        }
    }

})(jQuery);
